import { TFilterKey } from '@app.feature/activityFilter/modules/constant'
import { TOrderMapKey, TOrderSlice } from '../slice/orderSlice'

type TOrderProperty = Pick<TOrderSlice, 'order' | 'orderMap'>

type TUpsertOrderByKey = (
  options: TOrderProperty & {
    key: TOrderMapKey
  },
) => TOrderProperty

export const upsertOrderByKey: TUpsertOrderByKey = ({
  order,
  orderMap,
  key,
}) => {
  return {
    order: order + 1,
    orderMap: {
      ...orderMap,
      [key]: order,
    },
  }
}

type TUpsertOrderMultipleByKeys = (
  options: TOrderProperty & {
    target: {
      dataKey: TFilterKey
      ids: string[]
    }
  },
) => TOrderProperty

export const upsertOrderMultipleByKeys: TUpsertOrderMultipleByKeys = ({
  order,
  orderMap,
  target: { dataKey, ids },
}) => {
  const result = {
    order,
    orderMap,
  }

  ids.map((id) => {
    const targetKey = `${dataKey}.${id}`

    result.orderMap = {
      ...result.orderMap,
      [targetKey]: result.order,
    }
    result.order += 1
  })

  return result
}
